import { render, staticRenderFns } from "./ElButtonCurdGroup.vue?vue&type=template&id=1dec1cc1&scoped=true"
import script from "./ElButtonCurdGroup.vue?vue&type=script&lang=js"
export * from "./ElButtonCurdGroup.vue?vue&type=script&lang=js"
import style0 from "./ElButtonCurdGroup.vue?vue&type=style&index=0&id=1dec1cc1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dec1cc1",
  null
  
)

export default component.exports